import { connect } from 'react-redux'

import { CreatePromo } from '../components/Promotions/CreatePromo'
import { modalOpen, clearPromoError, createPromo } from '../modules/Promotions/actions'

const mapStateToProps = ({ promotions, auth }) => {
    return {
        id: promotions.id,
        promo_loading: promotions.promo_loading,
        modalClose: promotions.modalClose,
        user: auth.user,
        create_promo_error: promotions.create_promo_error,
    }
}

const mapDispatchToProps = {
    modalOpen,
    clearPromoError,
    createPromo,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePromo)
